import { useQuery } from "@tanstack/react-query";

const useVolunteerPending = () => {
  const userId = localStorage.getItem("uI");
  const user_id = userId - 786;
  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: volunteerPendingInfo = [],
  } = useQuery({
    queryKey: ["volunteerPending"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/voluntaryListPending/${user_id}`
      );
      const data = await res.json();
      return data;
    },
  });
  return [volunteerPendingInfo, isLoading, isError, error, isSuccess, refetch];
};

export default useVolunteerPending;

// const { refetch, data: patientInfo = [] } = useQuery({
//     queryKey: ["patient"],
//     queryFn: async () => {
//       const res = await fetch("http://192.168.0.84:5000/api/patientInfo");
//       const data = await res.json();
//       return data.result;
//     },

// .then(res => res.json())
// .then(data => setOrders(data));
